<template>

</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {onMounted} from "vue";
import {injectAxios, injectAuth} from "@/util/inject";

const axios = injectAxios();
const auth = injectAuth();
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  await authorize();
});

const authorize = async () => {
  if (!route.query?.code) {
    await router.push({name: "Login"});
    return;
  }

  const resp = await axios.post("/openid/token", route.query);
  await auth.login(resp.data.token);
};
</script>
